/**
 * This class describes the date and reason of store closure.
 */
export class StoreClosure {
  startDate: string;
  reason: string;

  /**
   * @param startDate the Monday starting from which store closure takes effect.
   * @param reason the reason why the store is closed.
   */
  constructor(startDate: string, reason: string) {
    this.startDate = startDate;
    this.reason = reason;
  }
}
